export const useHelpers = () => {
    
    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const identifySelectedRequestType = (arraySubtypes, dataToSearch) => {
        const foundValue = arraySubtypes.find(item => item.idgestiontipo === dataToSearch)

        return (foundValue)? foundValue.prefijo : 'No se ha seleccionado nada'
    }

    const getBodyForDateChange = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            // // datos globales
            idcredito: FormRequestGlobal.formState.idcredito,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            gestion_nuevo_dia_pago: FormRequestGlobal.formState.gestion_nuevo_dia_pago,
            aprobacion_check: FormRequestGlobal.formState.aprobacion_check,
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
        
    }

    const getBodyForTotalInsurancePayment = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            idcredito: FormRequestGlobal.formState.idcredito,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            gestion_total_seguro: convertToFloat(FormRequestGlobal.formState.total_seguro),
            check_seguro: (FormRequestGlobal.formState.check_seguro) ? 1 : 0,
            fecha_fin_contrato: FormRequestGlobal.formState.fecha_fin_contrato,
            gestion_cuota_seguro: parseFloat(String(FormRequestGlobal.formState.seguro).replace(/,/g, "")) || 0,
            aprobacion_check: FormRequestGlobal.formState.aprobacion_check,
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
        
    }

    const getBodyForGPSRemoval = ({user, FormRequestGlobal, isForUpdate}) => {

        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';
        
        return {
            idcredito: FormRequestGlobal.formState.idcredito,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            aprobacion_check: FormRequestGlobal.formState.aprobacion_check,
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
    }

    const convertToFloat = (formattedNumber) => {
        const cleanedValue = formattedNumber.replace(/,/g, '');
        const floatValue = parseFloat(cleanedValue);
        return isNaN(floatValue) ? 0 : floatValue; // Retorna 0 si no es un número válido
    };

    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });


    
    return Object.freeze({
        identifySelectedRequestType,
        getCurrentDate,
        getBodyForDateChange,
        getBodyForTotalInsurancePayment,
        getBodyForGPSRemoval,
        convertToFloat,
        numberFormatter
    })
}